__turbopack_context__.v({
  "bounceIn": "MainBanner-module-scss-module__b31S7a__bounceIn",
  "fadeInScale": "MainBanner-module-scss-module__b31S7a__fadeInScale",
  "fadeInStagger1": "MainBanner-module-scss-module__b31S7a__fadeInStagger1",
  "fadeInStagger2": "MainBanner-module-scss-module__b31S7a__fadeInStagger2",
  "fadeInUp": "MainBanner-module-scss-module__b31S7a__fadeInUp",
  "slide": "MainBanner-module-scss-module__b31S7a__slide",
  "stripe": "MainBanner-module-scss-module__b31S7a__stripe",
  "subtlePulse": "MainBanner-module-scss-module__b31S7a__subtlePulse",
});
